var $d180c4b372de6a9c$exports = {};
$d180c4b372de6a9c$exports = {
    "colorFormat": `Formato da cor`,
    "hex": `Hexagonal`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$d180c4b372de6a9c$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
